module.exports = __webpack_public_path__ + "static/media/zopsmart-final-logo.b20801f8.svg";